import type { Settings } from '@/shared/cache/slices/settings.types'
import { BillingSettings } from './BillingSettings'
import { AppearanceSettings } from './AppearanceSettings'

export interface GeneralSettingsProps {
  settings: Settings
  update: (patch: Partial<Settings>) => void
}

export function GeneralSettings({ settings, update }: GeneralSettingsProps) {
  return (
    <>
      <BillingSettings settings={settings} update={update} />
      <div className="my-8 border-t border-border/40" />
      <AppearanceSettings />
    </>
  )
}
